export default {
  "b2b.notifikace.title": "Notifications",
  "b2b.notifikace.empty": "You have no notifications",
  "b2b.notifikace.read-all": "Read all",
  "b2b.notifikace.delete-all": "Delete all",
  "b2b.notifikace.success-read":
    "{length, plural, one {Notification was read} other {Notifications were read}}",
  "b2b.notifikace.success-delete":
    "{length, plural, one {Notification was deleted} other {Notifications were deleted}}"
};
